var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"actions"}},[_c('Boutons'),_c('Telechargements',{staticStyle:{"margin-left":"5px"}}),_c('Affichages')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }